export const MIN_TERM_LENGTH = 1;
export const MIN_DEFINITION_LENGTH = 1;
